import { render } from "./Start.vue?vue&type=template&id=e35ff764&ts=true&lang=pug"
import script from "./Start.vue?vue&type=script&lang=ts"
export * from "./Start.vue?vue&type=script&lang=ts"

import "./Start.vue?vue&type=style&index=0&id=e35ff764&lang=scss"

import exportComponent from "/Users/olimago/Documents/www/escape-if-you-can-01/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__